import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import SecurityChecksPage from './SecurityChecksPage';
import { dataCaptureSelectors, saveSecurityChecksForm } from '../../store/dataCapture';
import { SECURITY_CHECKS_INFO, ROUTE_INFO_SECTION } from '../../utils/constants';

class SecurityChecksSection extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.history.push(ROUTE_INFO_SECTION);
  }

  render() {
    const { bankId, brandId, saveSecurityChecksForm, getBusinessData, showLoader } = this.props;

    return (
      <SecurityChecksPage
        brandId={brandId}
        bankId={bankId}
        saveSecurityChecksForm={saveSecurityChecksForm}
        backClick={this.businessBack}
        getBusinessData={getBusinessData}
        isLoading={showLoader}
      />
    );
  }
}

SecurityChecksSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveSecurityChecksForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveSecurityChecksForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, SECURITY_CHECKS_INFO),
  showLoader: dataCaptureSelectors.showLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SecurityChecksSection);
